/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

// required attributes
const ConfigurationKeyBaseR = t.interface({
  config_value: t.string
});

// optional attributes
const ConfigurationKeyBaseO = t.partial({
  config_description: t.string
});

export const ConfigurationKeyBase = t.intersection(
  [ConfigurationKeyBaseR, ConfigurationKeyBaseO],
  "ConfigurationKeyBase"
);

export type ConfigurationKeyBase = t.TypeOf<typeof ConfigurationKeyBase>;
